(function() { window.GUID_21156055_5bcd_47fa_8a18_f1efe9b59201 = { getGuid: function() { return "21156055-5bcd-47fa-8a18-f1efe9b59201"; } }; })();
//CS.on('contextmenu', '.CSE', function (e) {
//    e.preventDefault();
//    var $target = $(e.target);
//    var contextMenu = $("<div id=\"ContextMenuCSE\"><div class=\"CSEMenu CSEEdit\"><img src=\"/cdn/cs/images/gridview/edit.png\"/><span>edit</span></div></div>");
//    var offset = $target.offset();
//    var width = CS.win.width();
//    var height = CS.win.height();
//    var middleH = width / 2;
//    var middleV = height / 2;
//    var top = null;
//    var left = null;
//    var right = null;
//    var bottom = null;
//    if (e.clientX > middleH) {
//        left = 'auto';
//        right = (width - offset.left) - e.target.offsetWidth + 'px';
//    }
//    else {
//        left = offset.left + 'px';
//        right = 'auto';
//    }
//    if (e.clientY > middleV) {
//        top = 'auto';
//        bottom = (height - offset.top) + 'px';
//    }
//    else {
//        top = offset.top + e.target.offsetHeight + 'px';
//        bottom = 'auto';
//    }
//    contextMenu.css({
//        left: left, right: right, top: top, bottom: bottom
//    });
//    CS.body.append(contextMenu);
//    CS.off('mouseup.ContextMenuCSE');
//    CS.on('mouseup.ContextMenuCSE', function (e) {
//        var $bodyTarget = $(e.target);
//        if ($bodyTarget.hasClass('CSEEdit') || $bodyTarget.parent().hasClass('CSEEdit')) {
//            CSEEdit($target);
//        }
//        contextMenu.remove();
//    });
//});
//function CSEEdit(element) {
//    var cse = element.data('cse').split('|');
//    var data = {
//        entityType : cse[0],
//        ids : cse[1],
//        datas : cse[2]
//    };
//    ShowFormPopup(CSParameters.ControllerUrl + 'CSEEdit/' + CSParameters.SportEventId, data, null, function (result) {
//        if ($('form', result).length == 0) {
//            CS.trigger('CSESaved', result);
//            $(this).dialog("close");
//        }
//    });
//}

//# sourceMappingURL=cs.editelement.js.map
